import { render } from "./OrderProduct.vue?vue&type=template&id=586e7c98"
import script from "./OrderProduct.vue?vue&type=script&lang=js"
export * from "./OrderProduct.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__